import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;


  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${API}/api/admin/login`, { email, password });
      localStorage.setItem("adminToken", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Identifiants invalides");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
      <form
        onSubmit={handleLogin}
        className="bg-white/10 backdrop-blur-xl border border-white/10 p-8 rounded-2xl w-[400px] shadow-lg"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-indigo-400">
          Connexion Admin
        </h2>
        {error && <p className="text-red-400 text-sm mb-4">{error}</p>}

        <div className="flex flex-col gap-3">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
          <input
            type="password"
            placeholder="Mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
          />
          <button
            type="submit"
            className="mt-4 bg-indigo-600 hover:bg-indigo-500 rounded-lg py-2 font-semibold transition"
          >
            Se connecter
          </button>
        </div>
      </form>
    </div>
  );
}
